import React from 'react'
import PriorityStorePage from './PriorityStorePage'

const PriorityStorePageContainer = () => {
    return (
        <div className='PriorityStorePageContainer'>
            <PriorityStorePage/>
        </div>
    )
}

export default PriorityStorePageContainer